import { createContext, useState } from 'react';
import api from 'services/api';

export const TrocaContext = createContext();

export const TrocaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [troca, setTroca] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getTroca = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: troca?.filter,
        page: troca?.page,
        size: troca?.size,
        order: troca?.order,
        ...payload,
      });
      setTroca((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <TrocaContext.Provider
      value={{
        troca,
        getLoading,
        getTroca,
      }}
    >
      {children}
    </TrocaContext.Provider>
  );
};
